import { createReducer, on } from '@ngrx/store';
import * as FeedbackActions from './feedback.actions';
import { Feedback } from '../../models/Feedback';

export interface FeedbackState {
  allFeedback: Feedback[] | null;
  loading: boolean;
  error: any;
}

export const initialState: FeedbackState = {
  allFeedback: null,
  loading: false,
  error: null,
};

export const feedbackReducer = createReducer(
  initialState,
  on(FeedbackActions.loadFeedbackSuccess, (state, { feedback }) => ({
    ...state,
    allFeedback: feedback,
  })),
  on(FeedbackActions.submitFeedback, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FeedbackActions.submitFeedbackSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(FeedbackActions.submitFeedbackFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
